import { getUid } from "ol";

export const cambioOrdenCapasActivas = (map) => {
  const container = document.querySelector(".contenedor-capas-activas");
  let draggedElement = null;

  container.addEventListener("dragstart", function (event) {
    if (event.target.tagName === "IMG") {
      event.preventDefault();
      return;
    }
    if (event.target.classList.contains("control-opacidad")) {
      event.preventDefault();
      return;
    }

    if (event.target.classList.contains("capas-activas-panel")) {
      draggedElement = event.target;
      setTimeout(() => {
        draggedElement.style.display = "none";
      }, 0);
    }
  });

  container.addEventListener("dragend", function () {
    setTimeout(() => {
      draggedElement.style.display = "grid";
      draggedElement = null;
      updateLayerZIndex();
    }, 0);
  });

  container.addEventListener("dragover", function (event) {
    event.preventDefault();
    const afterElement = getDragAfterElement(container, event.clientY);
    const draggableElements = [
      ...container.querySelectorAll(".capas-activas-panel"),
    ];
    if (afterElement == null) {
      container.appendChild(draggedElement);
    } else {
      container.insertBefore(draggedElement, afterElement);
    }
  });

  function getDragAfterElement(container, y) {
    const draggableElements = [
      ...container.querySelectorAll(".capas-activas-panel"),
    ];

    return draggableElements.reduce(
      (closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) {
          return { offset, element: child };
        } else {
          return closest;
        }
      },
      { offset: Number.NEGATIVE_INFINITY }
    ).element;
  }

  //*/
  function updateLayerZIndex() {
    //lista de los paneles en el orden
    const panels = Array.from(
      document.querySelectorAll(".capas-activas-panel")
    );

    const highestZIndex = panels.length - 1;
    //sobre cada panel se actualiza el z index
    panels.forEach((panel, index) => {
      // sacar el id del panel
      const layerId = panel.getAttribute("data-layer-id");

      console.log("panel", panel);
      console.log("layerid", layerId);
      console.log("hisgestzindex", highestZIndex);
      console.log("index", index);

      // encontrar la layer de acuerdo al uid
      const layer = map.getAllLayers().find((l) => getUid(l) === layerId);
      if (layer) {
        //poner z index en base al la psoicion del panel en el dom
        layer.setZIndex(highestZIndex - index);
        console.log("zindex lugo asignacion", layer.getZIndex());
      }
    });
  }
};
